/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import messages from 'src/shared/app/signup/l10n/passwordSignupL10n';
import AuthenticationPasswordForm from 'src/shared/app/authentication/component/base/AuthenticationPasswordForm';
import useEventBraindateName from 'src/shared/domain/event/hook/useEventBraindateName';

type Props = {
  isPasswordSet: boolean,
  handleSubmit: (Object) => Promise<any>,
};

const SignupPasswordForm = ({
  isPasswordSet,
  handleSubmit,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |------------------------------,----------------------------------------------
   */

  const intl = useIntl();
  const { braindatePlatform: platform } = useEventBraindateName();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <AuthenticationPasswordForm
      legend={
        isPasswordSet
          ? ''
          : intl.formatMessage(messages.legendCreate, {
              platform,
            })
      }
      label={intl.formatMessage(
        isPasswordSet ? messages.labelEnter : messages.labelCreate,
        {
          platform,
        },
      )}
      submitCta={intl.formatMessage(messages.submit)}
      handleSubmit={handleSubmit}
    />
  );
};

export default compose(React.memo)(SignupPasswordForm);
